import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {

  constructor(
    protected httpClient: HttpClient
  ) { }

  getProviderListByCondition(parm: any, pageNum: number, pageSize: number): Observable<any[]> {
    let url = 'plan/api/business/provider/providersByCondition' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (!this.isEmpty(parm.pName)) {
      url = url + '&name=' + parm.pName;
    }
    if (!this.isEmpty(parm.pCode)) {
      url = url + '&code=' + parm.pCode;
    }
    if (!this.isEmpty(parm.typeIds) && parm.typeIds.length > 0) {
      url = url + '&type=' + parm.typeIds.toString();
    }
    return this.httpClient.get(url).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  async getProviderList() {
    const result: any = await this.httpClient.get('plan/api/business/provider/providers').toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  async getProvider(providerId: string) {
    const result: any = await this.httpClient.get(`plan/api/business/provider/provider/${providerId}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  // 获取供应商类型
  async getProviderTypeList() {
    const result: any = await this.httpClient.get('plan/api/business/provider/types').toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  // 新增供应商
  addProvider(provider: any): Observable<any[]> {
    return this.httpClient.post(`plan/api/business/provider/provider`, provider).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }

  // 批量删除供应商
  batchDeleteProviders(ids: any) {
    const ls: string[] = Array.from(ids);
    return this.httpClient.delete(`plan/api/business/provider/providers`, {
      params: { pnos: ls }
    }).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 更新供应商
  updateProvider(provider: any) {
    return this.httpClient.put('plan/api/business/provider/provider', provider).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 获取所有用户
  async getDirectors() {
    const result: any = await this.httpClient.get('plan/api/business/provider/directors').toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  // 获取供应商合同列表
  getProviderContractsByCondition(parm: any, pageNum: number, pageSize: number): Observable<any[]> {
    let url = 'plan/api/business/provider/contract/contractsByCondition' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (!this.isEmpty(parm.contractName)) {
      url = url + '&name=' + parm.contractName;
    }
    if (!this.isEmpty(parm.contractNo)) {
      url = url + '&subnumber=' + parm.contractNo;
    }
    if (!this.isEmpty(parm.pno)) {
      url = url + '&pno=' + parm.pno;
    }
    if (!this.isEmpty(parm.projectLeader)) {
      url = url + '&userId=' + parm.projectLeader;
    }
    if (!this.isEmpty(parm.status)) {
      url = url + '&status=' + parm.status;
    }
    return this.httpClient.get(url).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 获取供应商合同列表
  getProviderContracts(): Observable<any[]> {
    const url = 'plan/api/business/provider/contract/contracts';
    return this.httpClient.get(url).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 批量删除供应商合同
  batchDeleteContracts(ids: any) {
    const ls: string[] = Array.from(ids);
    return this.httpClient.delete(`plan/api/business/provider/contract/contracts`, {
      params: { ids: ls }
    }).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 新增供应商合同
  addContract(contract: any): Observable<any[]> {
    return this.httpClient.post(`plan/api/business/provider/contract/contract`, contract).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 根据供应商合同id获取供应商合同
  getContract(id: any): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/provider/contract/contract/${id}`).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 更新供应商合同
  updateProviderContract(contract: any) {
    return this.httpClient.put('plan/api/business/provider/contract/contract', contract).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 评价供应商合同
  evaluateProviderContract(contract: any) {
    return this.httpClient.put('plan/api/business/provider/contract/evaluateContract', contract).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  getProviderQsByCondition(object: any){
    let params = new HttpParams();
    if ( object.pageIndex !== undefined && object.pageIndex !== null){
      params = params.set('pageIndex', object.pageIndex.toString());
    }
    if ( object.pageSize !== undefined && object.pageSize !== null){
      params = params.set('pageSize', object.pageSize.toString());
    }
    if ( object.qsName !== undefined && object.qsName !== null){
      params = params.set('name', object.qsName);
    }
    if ( object.qsNo !== undefined && object.qsNo !== null){
      params = params.set('subnumber', object.qsNo);
    }
    if ( object.pno !== undefined && object.pno !== null){
      params = params.set('pno', object.pno);
    }
    if ( object.status !== undefined && object.status !== null){
      params = params.set('status', object.status);
    }
    return this.httpClient.get('plan/api/business/provider/qsheet/quotationsheets', {params}).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 获取报价单列表
  // getProviderQsByCondition(parm: any, pageNum: number, pageSize: number): Observable<any[]> {
  //   let url = 'plan/api/business/provider/qsheet/quotationsheets' + '?pageNum=' + pageNum +
  //     '&pageSize=' + pageSize;
  //   if (!this.isEmpty(parm.qsName)) {
  //     url = url + '&name=' + parm.qsName;
  //   }
  //   if (!this.isEmpty(parm.qsNo)) {
  //     url = url + '&subnumber=' + parm.qsNo;
  //   }
  //   if (!this.isEmpty(parm.pno)) {
  //     url = url + '&pno=' + parm.pno;
  //   }
  //   if (!this.isEmpty(parm.status)) {
  //     url = url + '&status=' + parm.status;
  //   }
  //   return this.httpClient.get(url).pipe(
  //     map((res: { data: any[] }) => res.data)
  //   );
  // }
  // 批量删除报价单
  batchDeleteQuotationsheets(ids: any) {
    const ls: string[] = Array.from(ids);
    return this.httpClient.delete(`plan/api/business/provider/qsheet/quotationsheets`, {
      params: { ids: ls }
    });
  }
  // 新增供应商报价单
  addQuotationSheet(quotationsheet: any) {
    return this.httpClient.post(`plan/api/business/provider/qsheet/quotationsheet`, quotationsheet);
  }
  // 根据供应商报价单id获取供应商报价单
  getQuotationSheet(id: any): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/provider/qsheet/quotationsheet/${id}`).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 更新供应商报价单
  updateQuotationSheet(quotationsheet: any) {
    return this.httpClient.put('plan/api/business/provider/qsheet/quotationsheet', quotationsheet).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 获取技术协议列表
  getProviderTaByCondition(parm: any, pageNum: number, pageSize: number): Observable<any[]> {
    let url = 'plan/api/business/provider/tagreement/tagreements' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (!this.isEmpty(parm.taName)) {
      url = url + '&name=' + parm.taName;
    }
    if (!this.isEmpty(parm.taNo)) {
      url = url + '&subnumber=' + parm.taNo;
    }
    if (!this.isEmpty(parm.pno)) {
      url = url + '&pno=' + parm.pno;
    }
    return this.httpClient.get(url).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 批量删除技术协议
  batchDeleteTas(ids: any) {
    const ls: string[] = Array.from(ids);
    return this.httpClient.delete(`plan/api/business/provider/tagreement/tagreements`, {
      params: { ids: ls }
    }).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 新增技术协议
  addTechnicalAgreement(ta: any): Observable<any[]> {
    return this.httpClient.post(`plan/api/business/provider/tagreement/tagreement`, ta).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 根据供应商技术协议id获取供应商技术协议
  getTechnicalAgreement(id: any): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/provider/tagreement/tagreement/${id}`).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }
  // 更新供应商技术协议
  updateTechnicalAgreement(ta: any) {
    return this.httpClient.put('plan/api/business/provider/tagreement/tagreement', ta).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }

  // 查询供应商费用
  async getProviderCostByType(flag: string) {
    let url = 'plan/api/business/provider/cost';
    const date = new Date();
    url = url + `/${date.getFullYear()}/${flag}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  // 查询供应商费用top
  async getProviderCostTop() {
    const url = 'plan/api/business/provider/cost/top';
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }

  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
